import { render, staticRenderFns } from "./PeriodicDetail.vue?vue&type=template&id=4914c189&"
import script from "./PeriodicDetail.vue?vue&type=script&lang=js&"
export * from "./PeriodicDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports